import { ProjectsAPI } from 'ducks/types/api-types';
import { ProjectItem } from 'ducks/types/store-types';
import { WithUUID } from 'ducks/types/type-helpers';
import { normalizeObjUUID } from 'ducks/utils';

export const normalizeProjects = (projects: ProjectsAPI[]): WithUUID<ProjectItem>[] =>
  projects
    .map((project) => {
      const { project_name } = project;
      return normalizeObjUUID({
        ...project,
        avatar: project_name.substring(0, 2),
      });
    })
    .sortObject('project_name', 'asc');
